import { SupportSidePanel } from "components/SidePanel/Support/SupportSidePanel";
import React from "react";

interface SupportArticleButtonProps {
  articleId: number
  label: string
}

const SupportArticleButton = ({ articleId, label }: SupportArticleButtonProps) => (
  <SupportSidePanel
    articleId={articleId}
    trigger={<a
      tabIndex={-1}
      onClick={() => { }}
      className="button-support-article"
    >
      {label}
    </a>}
  />
);

export default SupportArticleButton;
